import React from "react";
import { Link } from "react-router-dom";

const Wishlist = ({ wishlist, onRemoveFromWishlist }) => {
  return (
    <div className="container my-5">
      <h2 className="mb-4 main-color text-center">My Wishlist</h2>

      {wishlist.length === 0 ? (
        <p className="text-center">Your wishlist is empty.</p>
      ) : (
        <div className="row">
          {wishlist.map((product) => (
            <div key={product.id} className="col-md-4 mb-4">
              <div className="card h-100 shadow-sm">
                <img
                  src={product.image}
                  alt={product.name}
                  className="card-img-top"
                  style={{ height: "250px", objectFit: "cover" }}
                />
                <div className="card-body text-center">
                  <h5 className="card-title">{product.name}</h5>
                  <p className="card-text">${product.price}</p>

                  <div className="d-flex justify-content-center gap-3">
                    <Link
                      to={`/product/${product.id}`}
                      className="btn btn-outline-custom"
                    >
                      View Details
                    </Link>
                    <button
                      className="btn btn-danger"
                      onClick={() => onRemoveFromWishlist(product.id)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Wishlist;
